const getIcelandicDateTime = () => {
	const padLeft = (n) => n < 10 ? '0' + n : n;
	const date = new Date();
	const time = padLeft(date.getHours()) + ':' + padLeft(date.getMinutes());
	const weekdays = ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur'];
	const monthNames = ["janúar", "febrúar", "mars", "apríl", "maí", "júní", "júlí", "ágúst", "september", "október", "nóvember", "desember"];
	return weekdays[date.getDay()] + ' ' + date.getDate() + '. ' + monthNames[date.getMonth()] + ' ' + date.getFullYear() + ' - ' + time;
};

site.skolaskjar = {
	refreshRateInMinutes: 10,
	autoplayTimeoutInSeconds: 10,

	init: function () {
		if (!document.body.classList.contains('skolaskjar')) {
			return false;
		}

		site.owl.init('#custom-slider > .items', {
			loop: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: site.skolaskjar.autoplayTimeoutInSeconds * 1000,
			smartSpeed: 500,
			items: 1,
		});

		const data = document.querySelector('#custom-slider .items').dataset;
		const timestamp = parseInt(data.timestamp, 10);

		const minute = 1000 * 60;
		const footer = document.getElementById('footer');
		const getDate = () => {
			const time = getIcelandicDateTime();
			footer.innerHTML = `<span>${time}</span><span><img src="/static/themes/2017/images/logo_nav.png" alt="logo"></span>`;
		};

		const mainLogo = document.createElement('img');
		mainLogo.src = '/static/themes/2017/images/logo.png';
		mainLogo.classList.add('main-logo');
		document.querySelectorAll('.item .text').forEach((t) => {
			t.innerHTML += mainLogo.outerHTML;
		});

		const fetchForUpdates = () =>
			fetch('/_/moya/adverts/region/show/' + data.region, {
				method: 'GET',
				cache: 'no-cache',
				credentials: 'omit',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
				},
				redirect: 'follow',
				referrerPolicy: 'no-referrer',
			}).then((r) => r.text())
				.then((response) => {
				if (parseInt(response.replace( /\D+/g, ''), 10) > timestamp) {
					location.reload();
				}
			});

		getDate();
		// Refresh date / time
		setInterval(getDate, minute);

		setInterval(fetchForUpdates, site.skolaskjar.refreshRateInMinutes * minute);
	},
};

site.inits.push('site.skolaskjar.init()');
